import React from 'react';
import WeeklyRevenue from './components/WeeklyRevenue';
import TotalSpent from './components/TotalSpent';

import Widget from 'components/widget/Widget';
import RecentTransactionsTable from './components/RecentTransactionsTable';
import {formatCurrency} from '../../../stores/JSHelper';
import UseAccountStore from '../../../stores/DataStore';
import {useEffect} from 'react';
import Spinner from '../../../components/spinner';
import {AccountSummaryResponse} from '../../../stores/types';
import {HiOutlineCash} from 'react-icons/hi';
import DailyTraffic from './components/DailyTraffic';

const getDaysAt = (summary: AccountSummaryResponse, days: number) => {
  for (const txn of summary.periods) {
    if (txn.days === days) {
      return txn;
    }
  }
  return {
    totalCredit: 0,
    totalDebit: 0,
    creditCount: 0,
    debitCount: 0,
  };
};

const textMap = {
  1: 'Today',
  7: 'This Week',
  30: 'This Month',
  90: 'This Quarter',
};

const Dashboard = () => {
  const {account, summary, fetchSummary} = UseAccountStore();

  useEffect(() => {
    (async () => {
      await fetchSummary();
    })();
  }, [account]);

  if (summary === null) {
    return <Spinner />;
  }

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 3xl:grid-cols-6">
        {[1, 7, 30, 90].map((d) => {
          let daysAt = getDaysAt(summary, d);
          return (
            <React.Fragment key={d}>
              <Widget
                icon={<HiOutlineCash className="h-7 w-7" />}
                title={`Credits ${textMap[d]}`}
                subtitle={`${formatCurrency(daysAt?.totalCredit ?? 0, 'INR')} (${daysAt?.creditCount ?? 0})`}
              />
              <Widget
                icon={<HiOutlineCash className="h-7 w-7" />}
                title={`Debits ${textMap[d]}`}
                subtitle={`${formatCurrency(daysAt?.totalDebit ?? 0, 'INR')} (${daysAt?.debitCount ?? 0})`}
              />
            </React.Fragment>
          );
        })}
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5">
        <WeeklyRevenue summary={summary} />
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent summary={summary} />
        {summary.walletStats && <DailyTraffic summary={summary} />}
      </div>
      <div className="my-5">
        <div>
          <RecentTransactionsTable transactions={summary.recentTransactions} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
